export const ConvertDateMongo = (date?:string)=>{
  const newDate = date?.substring(0,10)
  
  return newDate
}